import React, { useState } from 'react';
import { X, Smartphone } from 'lucide-react';
import { InstallAppAction } from './InstallAppAction';

const DISMISS_KEY = 'halubri_install_banner_dismissed';

export const InstallBanner = () => {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');

  if (dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <InstallAppAction>
      {(install) => (
        <div className="flex items-center gap-3 bg-white rounded-2xl p-3 pr-1 shadow-sm border border-zinc-100 animate-fade-in" data-testid="install-banner">
          <img src="/logo192.png" alt="" className="w-11 h-11 rounded-xl shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-barlow font-bold text-zinc-800 leading-tight">Instale a app HáLubri</p>
            <p className="text-xs text-zinc-500">Acesso rápido a partir do ecrã principal</p>
          </div>
          <button onClick={install} className="h-10 px-4 rounded-xl bg-sonangol-red text-white text-sm font-bold flex items-center gap-1 active:scale-95 transition-transform"
            data-testid="install-banner-btn">
            <Smartphone className="w-4 h-4" />Instalar
          </button>
          <button onClick={dismiss} aria-label="Fechar" className="w-10 h-10 flex items-center justify-center text-zinc-400 hover:text-zinc-600"
            data-testid="install-banner-dismiss">
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
    </InstallAppAction>
  );
};

export default InstallBanner;
